import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import MoveIcon from "@material-ui/icons/Forward";
import HelpIcon from "@material-ui/icons/HelpOutline";
import { mdiAccountCash, mdiAccountCheck } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import DefaultInfoFieldsReferees from "../../constants/DefaultInfoFieldsReferees";
import { languages } from "../../constants/languages";
import SignupNameQuestion from "../../constants/SignupNameQuestion";
import EditAdminContainer from "../../containers/admins/EditAdminContainer";
import EditRefereeContainer from "../../containers/schedule/EditRefereeContainer";
import EditTeamContainer from "../../containers/teams/EditTeamContainer";
import { exportRefereeQRCodes } from "../../containers/teams/ExportRefereeQRCodesContainer";
import { exportReferees } from "../../containers/teams/ExportRefereesContainer";
import { exportTeamQRCodes } from "../../containers/teams/ExportTeamQRCodesContainer";
import { exportTeams } from "../../containers/teams/ExportTeamsContainer";
import ImportPlayersContainer from "../../containers/teams/ImportPlayersContainer";
import TeamsAsRefereesContainer from "../../containers/teams/TeamsAsRefereesContainer";
import TeamsTableRowContainer from "../../containers/teams/TeamsTableRowContainer";

export const columnData = [
  {
    id: "present",
    numeric: false,
    label: <Icon path={mdiAccountCheck} size={1} />,
    style: {
      width: 25,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  {
    id: "payed",
    numeric: false,
    label: <Icon path={mdiAccountCash} size={1} />,
    style: {
      width: 25,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  {
    id: "name",
    numeric: false,
    label: languages.teams.name,
  },
  // {
  //   id: "extraField",
  //   numeric: false,
  //   disablePadding: true,
  //   label: languages.teams.contactPerson
  // },
  {
    id: "email",
    numeric: false,
    label: languages.teams.email,
  },
  {
    id: "added",
    numeric: false,
    label: languages.teams.added,
  },
  {
    id: "country",
    numeric: false,
    label: languages.teams.country,
  },
  {
    id: "refereeCountry",
    numeric: false,
    label: languages.teams.country,
  },
  // PSD ecup
  {
    id: "psdClubId",
    numeric: false,
    label: languages.teams.psdClub,
  },
  {
    id: "logo",
    numeric: false,
    label: languages.teams.logo,
  },
  {
    id: "dressingRoom",
    numeric: false,
    label: languages.teams.dressingRoom,
  },
  {
    id: "players",
    numeric: false,
    label: languages.teams.players,
  },
  {
    id: "shareURL",
    numeric: false,
    label: (
      <>
        {languages.teamInfo.shareURL}
        <Tooltip
          title={languages.teamInfo.shareURLDescription4}
          placement="top"
        >
          <HelpIcon
            style={{
              height: 15,
              width: 15,
              marginLeft: 5,
              position: "relative",
              top: 2,
            }}
          />
        </Tooltip>
      </>
    ),
    style: {
      width: 120,
    },
  },
  {
    id: "refereeShareURL",
    numeric: false,
    label: languages.teamInfo.shareURL,
    style: {
      width: 120,
    },
  },
  {
    id: "language",
    numeric: false,
    label: languages.teamInfo.signupLanguage,
  },
];

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  createSortHandlerQuestion = (property) => (event) => {
    this.props.onRequestSort(event, property, true);
  };

  createSortHandlerProduct = (property) => (event) => {
    this.props.onRequestSort(event, property, false, true);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount } =
      this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell style={{ textAlign: "left" }}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
              color="primary"
              style={{ padding: "0px 0px 5px 0px" }}
            />
          </TableCell>
          {columnData.map((column) => {
            let show = (
              (this.props.tournament.defaultFields || {})[column.id] || {}
            ).show;
            if (
              show === undefined &&
              !this.props.refereesPage &&
              !this.props.adminsPage &&
              (column.id === "players" || column.id === "logo")
            ) {
              show = true;
            } else if (
              show === undefined &&
              (this.props.tournament.signupOpen || false) &&
              column.id === "email" &&
              !this.props.adminsPage
            ) {
              show = true;
            } else if (
              show === undefined ||
              this.props.refereesPage ||
              this.props.adminsPage
            ) {
              show = false;
            }
            if (column.id === "name") {
              show = true;
            }
            if (
              column.id === "players" &&
              this.props.tournament.individualPlayers
            ) {
              show = false;
            }
            if (column.id === "refereeCountry" && this.props.refereesPage) {
              show = (
                (this.props.tournament.defaultFields || {})[column.id] || {}
              ).show;
            } else if (
              column.id === "refereeCountry" &&
              !this.props.refereesPage
            ) {
              show = false;
            }
            if (column.id === "shareURL" && this.props.refereesPage) {
              show = false;
            }
            if (column.id === "refereeShareURL" && this.props.refereesPage) {
              show =
                ((this.props.tournament.defaultFields || {})[column.id] || {})
                  .show ||
                ((this.props.tournament.defaultFields || {})[column.id] || {})
                  .show === undefined;
            } else if (
              column.id === "refereeShareURL" &&
              !this.props.refereesPage
            ) {
              show = false;
            }
            if (
              column.id === "present" &&
              this.props.tournament.requireCheckIn &&
              !this.props.refereesPage &&
              !this.props.adminsPage
            ) {
              show = true;
            }

            // PSD ecup
            if (
              column.id === "psdClubId" &&
              this.props.tournament[".key"] === "G64irmoaJPIkFfYKkfUP"
            ) {
              show = true;
            } else if (column.id === "psdClubId") {
              show = false;
            }

            if (
              column.id === "language" &&
              (this.props.tournament.lang || []).length < 2
            ) {
              show = false;
            }

            return show ? (
              <TableCell
                key={column.id}
                align={column.numeric ? "right" : "inherit"}
                sortDirection={orderBy === column.id ? order : false}
                style={column.style || {}}
              >
                {column.id === "players" ? (
                  column.label
                ) : (
                  <Tooltip
                    title={languages.teams.sort}
                    placement={column.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={this.createSortHandler(column.id)}
                      style={{ fontSize: "0.8125rem" }}
                    >
                      <span className="ColumnLabel">{column.label}</span>
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            ) : null;
          }, this)}

          {!this.props.refereesPage &&
            !this.props.adminsPage &&
            (this.props.tournament.showTeamSignupQuestion2Table !== undefined
              ? this.props.tournament.showTeamSignupQuestion2Table
              : this.props.tournament.showTeamSignupQuestion2 !== undefined
              ? this.props.tournament.showTeamSignupQuestion2
              : false) && (
              <TableCell sortDirection={orderBy === "gamertag" ? order : false}>
                <Tooltip
                  title={languages.teams.sort}
                  placement={"bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === "gamertag"}
                    direction={order}
                    onClick={this.createSortHandlerQuestion("gamertag")}
                    style={{ fontSize: "0.8125rem" }}
                  >
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {this.props.tournament.teamSignupQuestion2 ||
                        SignupNameQuestion.gamertagQuestion[
                          (this.props.tournament.lang || [])[0]
                            ? (this.props.tournament.lang || [])[0]
                            : languages.getLanguage()
                        ]}
                    </span>
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            )}

          {!this.props.refereesPage &&
            !this.props.adminsPage &&
            Object.keys(this.props.tournament.questions || {})
              .filter(
                (key) => this.props.tournament.questions[key].perSignup !== true
              )
              .sort((a, b) => {
                const qA = this.props.tournament.questions[a];
                const qB = this.props.tournament.questions[b];
                if (qA.num > qB.num) {
                  return 1;
                } else if (qA.num < qB.num) {
                  return -1;
                } else {
                  return 0;
                }
              })
              .map((key) => {
                let extraField = this.props.tournament.questions[key];
                return extraField.show ? (
                  <TableCell
                    key={key}
                    sortDirection={orderBy === key ? order : false}
                  >
                    <Tooltip
                      title={languages.teams.sort}
                      placement={"bottom-start"}
                      enterDelay={300}
                    >
                      <TableSortLabel
                        active={orderBy === key}
                        direction={order}
                        onClick={this.createSortHandlerQuestion(key)}
                        style={{ fontSize: "0.8125rem" }}
                      >
                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "2",
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {extraField.name}
                        </span>
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                ) : null;
              })}

          {!this.props.refereesPage &&
            !this.props.adminsPage &&
            Object.keys(this.props.tournament.questions || {})
              .filter(
                (key) => this.props.tournament.questions[key].perSignup === true
              )
              .sort((a, b) => {
                const qA = this.props.tournament.questions[a];
                const qB = this.props.tournament.questions[b];
                if (qA.num > qB.num) {
                  return 1;
                } else if (qA.num < qB.num) {
                  return -1;
                } else {
                  return 0;
                }
              })
              .map((key) => {
                let extraField = this.props.tournament.questions[key];
                return extraField.show ? (
                  <TableCell
                    key={key}
                    sortDirection={orderBy === key ? order : false}
                  >
                    <Tooltip
                      title={languages.teams.sort}
                      placement={"bottom-start"}
                      enterDelay={300}
                    >
                      <TableSortLabel
                        active={orderBy === key}
                        direction={order}
                        onClick={this.createSortHandlerQuestion(key)}
                        style={{ fontSize: "0.8125rem" }}
                      >
                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "2",
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {extraField.name}
                        </span>
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                ) : null;
              })}

          {!this.props.refereesPage &&
            !this.props.adminsPage &&
            Object.keys(this.props.tournament.products || {})
              .filter((p) => !this.props.tournament.products[p].alwaysAdd)
              .sort((a, b) => {
                const pA = this.props.tournament.products[a];
                const pB = this.props.tournament.products[b];
                if (pA.num > pB.num) {
                  return 1;
                } else if (pA.num < pB.num) {
                  return -1;
                } else {
                  return 0;
                }
              })
              .map((key) => {
                let product = this.props.tournament.products[key];
                return product.show || product.show === undefined ? (
                  <TableCell
                    key={key}
                    sortDirection={orderBy === key ? order : false}
                  >
                    <Tooltip
                      title={languages.teams.sort}
                      placement={"bottom-start"}
                      enterDelay={300}
                    >
                      <TableSortLabel
                        active={orderBy === key}
                        direction={order}
                        onClick={this.createSortHandlerProduct(key)}
                        style={{ fontSize: "0.8125rem" }}
                      >
                        {product.name}
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                ) : null;
              })}

          {!this.props.refereesPage &&
            !this.props.adminsPage &&
            Object.keys(this.props.tournament.infoFields || {}).map((key) => {
              let extraField = this.props.tournament.infoFields[key];
              return (
                <TableCell
                  key={key}
                  sortDirection={orderBy === key ? order : false}
                >
                  <Tooltip
                    title={languages.teams.sort}
                    placement={"bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === key}
                      direction={order}
                      onClick={this.createSortHandler(key)}
                      style={{ fontSize: "0.8125rem" }}
                    >
                      {extraField.name}
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              );
            })}

          {!this.props.refereesPage &&
            !this.props.adminsPage &&
            this.props.days.length > 2 &&
            ["prefer", "preferNot", "notAvailable"]
              .filter(
                (p) => ((this.props.tournament.teamWishes || {})[p] || {}).show
              )
              .map((key) => {
                return (
                  <TableCell
                    key={key}
                    sortDirection={orderBy === key ? order : false}
                  >
                    <Tooltip
                      title={languages.teams.sort}
                      placement={"bottom-start"}
                      enterDelay={300}
                    >
                      <TableSortLabel
                        active={orderBy === key}
                        direction={order}
                        onClick={this.createSortHandlerProduct(key)}
                        style={{ fontSize: "0.8125rem" }}
                      >
                        {languages.teamInfo[key + "Wish"]}
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                );
              })}

          {this.props.refereesPage &&
            Object.keys(DefaultInfoFieldsReferees).map((key) => {
              let infoField = DefaultInfoFieldsReferees[key];
              let show = (
                (this.props.tournament.defaultFieldsReferees || {})[key] || {}
              ).show;
              if (show === undefined) {
                show = false;
              }
              return show ? (
                <TableCell
                  key={key}
                  sortDirection={orderBy === key ? order : false}
                >
                  <Tooltip
                    title={languages.teams.sort}
                    placement={"bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === key}
                      direction={order}
                      onClick={this.createSortHandler(key)}
                      style={{ fontSize: "0.8125rem" }}
                    >
                      {infoField.name}
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              ) : null;
            })}
          {this.props.refereesPage &&
            Object.keys(this.props.tournament.infoFieldsReferees || {}).map(
              (key) => {
                let extraField = this.props.tournament.infoFieldsReferees[key];
                return (
                  <TableCell
                    key={key}
                    sortDirection={orderBy === key ? order : false}
                  >
                    <Tooltip
                      title={languages.teams.sort}
                      placement={"bottom-start"}
                      enterDelay={300}
                    >
                      <TableSortLabel
                        active={orderBy === key}
                        direction={order}
                        onClick={this.createSortHandler(key)}
                        style={{ fontSize: "0.8125rem" }}
                      >
                        {extraField.name}
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                );
              }
            )}
          {this.props.adminsPage &&
            [
              languages.admins.manageGeneral,
              languages.admins.manageTeams,
              languages.admins.manageFormat,
              languages.admins.manageSchedule,
              languages.admins.managePresentation,
              languages.admins.managePublicWebsite,
              languages.admins.manageSlideshow,
              languages.admins.manageDesign,
              languages.admins.manageResults,
              languages.admins.managePhases,
            ].map((key) => {
              return (
                <TableCell
                  key={key}
                  sortDirection={orderBy === key ? order : false}
                >
                  <Tooltip
                    title={languages.teams.sort}
                    placement={"bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === key}
                      direction={order}
                      onClick={this.createSortHandler(key)}
                      style={{ fontSize: "0.8125rem" }}
                    >
                      {key}
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              );
            })}
          <TableCell />
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: 0,
    paddingLeft: 0,
    borderRadius: 5,
    minHeight: 50,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.dark,
          backgroundColor: lighten(theme.palette.secondary.light, 0.4),
        }
      : {
          color: lighten(theme.palette.secondary.light, 0.4),
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 10%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
});

let EnhancedTableToolbar = (props) => {
  const { numSelected, classes } = props;
  const user = window.firebase.auth().currentUser;
  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography variant="subtitle1" style={{ paddingLeft: 15 }}>
            {numSelected} {languages.teams.selected}
          </Typography>
        ) : (
          props.dropdown
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <div style={{ display: "inline", marginRight: 10 }}>
            {!props.refereesPage && !props.adminsPage && (
              <Button
                aria-label="Move"
                onClick={props.toggleMoveDialog}
                disabled={props.divisions.length === 1}
              >
                <span className={"button-text"}>{languages.teams.move}</span>
                <MoveIcon />
              </Button>
            )}

            {user &&
              !props.refereesPage &&
              !props.adminsPage &&
              (user.uid === "ROo6LrDGUbO705Hv0O3mnKVZrng2" || // Account Christiaan
                user.uid === "1Aakz7G1nCSRtODZhU3DGgJYXb93" || // Account SportsGen
                user.uid === "qwVXeKNiBzMz3RyUJSAJFLrkFnH2") && ( // Account Abel
                <Button
                  aria-label="Delete Players"
                  onClick={props.toggleDeletePlayersDialog}
                >
                  <span className={"button-text"}>
                    {languages.teams.deletePlayers}
                  </span>
                  <DeleteIcon />
                </Button>
              )}
            <Button aria-label="Delete" onClick={props.toggleDialog}>
              <span className={"button-text"}>{languages.teams.delete}</span>
              <DeleteIcon />
            </Button>
          </div>
        ) : (
          <div>
            {props.refereesPage ? (
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <TeamsAsRefereesContainer
                  tournament={props.tournament}
                  allTeams={props.allTeams}
                  teams={props.teams}
                />
                <Button
                  size="small"
                  variant="outlined"
                  color="default"
                  onClick={props.handleExportMenuOpen}
                >
                  {languages.export.export}
                </Button>
                <Menu
                  anchorEl={props.exportMenuAnchorEl}
                  open={Boolean(props.exportMenuAnchorEl)}
                  onClose={props.handleExportMenuClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem onClick={props.handleExportReferees}>
                    {props.tournament.useJudges
                      ? languages.referees.judges
                      : languages.schedule.referees}
                  </MenuItem>
                  {props.tournament.liveLink && (
                    <MenuItem onClick={props.handleExportRefereeQR}>
                      {languages.teams.exportQRcodes}
                    </MenuItem>
                  )}
                </Menu>
                <EditRefereeContainer
                  tournament={props.tournament}
                  sportParks={props.sportParks}
                  days={props.days}
                  divisions={props.divisions}
                  allTeams={props.allTeams}
                  allTeamsByKey={props.allTeamsByKey}
                />
              </div>
            ) : props.adminsPage ? (
              <EditAdminContainer tournament={props.tournament} />
            ) : (
              <div style={{ display: "flex", gap: 10 }}>
                <ImportPlayersContainer
                  tournament={props.tournament}
                  division={props.division}
                />
                {props.contactInfoLoaded && (
                  <>
                    <Button
                      size="small"
                      variant="outlined"
                      color="default"
                      onClick={props.handleExportMenuOpen}
                    >
                      {languages.export.export}
                    </Button>
                    <Menu
                      anchorEl={props.exportMenuAnchorEl}
                      open={Boolean(props.exportMenuAnchorEl)}
                      onClose={props.handleExportMenuClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      getContentAnchorEl={null}
                    >
                      <MenuItem onClick={props.handleExportTeams}>
                        {props.tournament.individualPlayers
                          ? languages.teams.players
                          : languages.tournament.teams}
                      </MenuItem>
                      {((
                        (props.tournament.defaultFields || {})["players"] || {}
                      ).show ||
                        (props.tournament.defaultFields || {})["players"] ===
                          undefined) &&
                        !props.tournament.individualPlayers && (
                          <MenuItem onClick={props.handleExportPlayers}>
                            {languages.teams.players}
                          </MenuItem>
                        )}
                      {props.tournament.liveLink && (
                        <MenuItem onClick={props.handleExportQR}>
                          {languages.teams.exportQRcodes}
                        </MenuItem>
                      )}
                    </Menu>
                  </>
                )}

                <EditTeamContainer
                  tournament={props.tournament}
                  division={props.division}
                  tournamentStatus={props.tournamentStatus}
                  toggleFinishedDialog={props.toggleFinishedDialog}
                  user={props.user}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  tableWrapper: {
    overflowX: "auto",
  },
});

class TeamsTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      page: 0,
      rowsPerPage: 100,
      exportMenuAnchorEl: null,
    };
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleExportMenuOpen = (event) => {
    this.setState({ exportMenuAnchorEl: event.currentTarget });
  };

  handleExportMenuClose = () => {
    this.setState({ exportMenuAnchorEl: null });
  };

  handleExportTeams = () => {
    exportTeams(
      this.props.tournament,
      this.props.teamsContactInfo,
      this.props.divisionsObject
    );
    this.handleExportMenuClose();
  };

  handleExportQR = () => {
    exportTeamQRCodes(this.props.tournament, this.props.divisionsObject);
    this.handleExportMenuClose();
  };

  handleExportReferees = () => {
    exportReferees(this.props.tournament, this.props.teams);
    this.handleExportMenuClose();
  };

  handleExportRefereeQR = () => {
    exportRefereeQRCodes(this.props.tournament);
    this.handleExportMenuClose();
  };

  handleExportPlayers = () => {
    this.props.handleExportPlayers();
    this.handleExportMenuClose();
  };

  isSelected = (id) => {
    const selected = this.props.selected.map((team) => team.id);
    return selected.indexOf(id) !== -1;
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;

    const selected = this.props.selected;

    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, this.props.teams.length - page * rowsPerPage);

    return (
      <div className={classes.root}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          tournament={this.props.tournament}
          division={this.props.division}
          toggleDialog={this.props.toggleDialog}
          toggleMoveDialog={this.props.toggleMoveDialog}
          toggleDeletePlayersDialog={this.props.toggleDeletePlayersDialog}
          divisions={this.props.divisions}
          tournamentStatus={this.props.tournamentStatus}
          toggleFinishedDialog={this.props.toggleFinishedDialog}
          dropdown={this.props.dropdown}
          refereesPage={this.props.refereesPage}
          adminsPage={this.props.adminsPage}
          sportParks={this.props.sportParks}
          days={this.props.days}
          allTeams={this.props.allTeams}
          allTeamsByKey={this.props.allTeamsByKey}
          teams={this.props.teams}
          teamsContactInfo={this.props.teamsContactInfo}
          contactInfoLoaded={this.props.contactInfoLoaded}
          divisionsObject={this.props.divisionsObject}
          handleExportMenuOpen={this.handleExportMenuOpen}
          handleExportMenuClose={this.handleExportMenuClose}
          exportMenuAnchorEl={this.state.exportMenuAnchorEl}
          handleExportTeams={this.handleExportTeams}
          handleExportPlayers={this.handleExportPlayers}
          handleExportQR={this.handleExportQR}
          handleExportReferees={this.handleExportReferees}
          handleExportRefereeQR={this.handleExportRefereeQR}
        />
        <div className={classes.tableWrapper}>
          <Table size="small">
            <EnhancedTableHead
              numSelected={selected.length}
              order={this.props.order}
              orderBy={this.props.orderBy}
              onSelectAllClick={this.props.handleSelectAllClick}
              onRequestSort={this.props.handleRequestSort}
              rowCount={this.props.teams.length}
              tournament={this.props.tournament}
              refereesPage={this.props.refereesPage}
              adminsPage={this.props.adminsPage}
              days={this.props.days}
            />
            <TableBody>
              {this.props.teams
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((team) => {
                  const isSelected = this.isSelected(team.id);
                  return (
                    <TeamsTableRowContainer
                      key={team.id}
                      isSelected={isSelected}
                      handleClick={this.props.handleClick}
                      team={team}
                      orderBy={this.props.orderBy}
                      tournament={this.props.tournament}
                      division={this.props.division}
                      tournamentStatus={this.props.tournamentStatus}
                      toggleFinishedDialog={this.props.toggleFinishedDialog}
                      refereesPage={this.props.refereesPage}
                      adminsPage={this.props.adminsPage}
                      user={this.props.user}
                      sportParks={this.props.sportParks}
                      days={this.props.days}
                      divisions={this.props.divisions}
                      allTeams={this.props.allTeams}
                      allTeamsByKey={this.props.allTeamsByKey}
                      playersContactInfo={this.props.playersContactInfo}
                      playersContactInfoLoaded={
                        this.props.playersContactInfoLoaded
                      }
                    />
                  );
                })}
              {emptyRows > 0 && false && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={20}
                  rowsPerPageOptions={[50, 100, 150]}
                  count={this.props.teams.length}
                  rowsPerPage={rowsPerPage}
                  labelRowsPerPage={languages.teams.rowsPerPage}
                  labelDisplayedRows={({ from, to, count }) =>
                    from + "-" + to + " " + languages.teams.of + " " + count
                  }
                  page={page}
                  backIconButtonProps={{
                    "aria-label": "Previous Page",
                  }}
                  nextIconButtonProps={{
                    "aria-label": "Next Page",
                  }}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  style={{ borderBottom: "0 solid gray" }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </div>
    );
  }
}

TeamsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TeamsTable);
